import React from "react";
import ReactDOM from "react-dom/client";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Loader } from "./components/Loader";
import "./styles/responsive.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
const App = lazy(() => import("./App"));
const FindStore = lazy(() => import("./FindStore"));
const Menu = lazy(() => import("./Menu"));
const NotFound = lazy(() => import("./NotFound"));
const Sign = lazy(() => import("./Sign"))
const IndexPage = lazy(() => import("./IndexPage"))
root.render(
  <BrowserRouter>
    <Suspense fallback={<Loader />}>
      <Routes>
          <Route path="/" element={<IndexPage />}></Route>
          <Route path="/Home" element={<App />}></Route>
          <Route path="/FindStor" element={<FindStore />}></Route>
          <Route path="/Menu/All" element={<Menu component="default" />}></Route>
          <Route path="/Menu/All/:name" element={<Menu component="default" />}></Route>
          <Route path="/Menu/previous" element={<Menu component="previous" />}></Route>
          <Route path="/Menu/favorites" element={<Menu component="favorites" />}></Route>
          <Route path="/Menu/featured" element={<Menu component="Featured" />}></Route>
          <Route path="/signIn" element={<Sign />}></Route>
          <Route path="/*" element={<NotFound />}></Route>
      </Routes>
    </Suspense>
  </BrowserRouter>
);
